import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type P_PersonKnowledgeListQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type P_PersonKnowledgeListQuery = { PersonKnowledgeList?: Array<{ __typename: 'PersonKnowledge', id: string, type?: string | null, mgsaDimension?: string | null, displayName?: string | null, description?: string | null, source?: string | null, sourceRef?: string | null, sourceDate?: any | null, confidence?: number | null } | null> | null };


export const P_PersonKnowledgeListDocument = /*#__PURE__*/ gql`
    query p_PersonKnowledgeList($filter: JSON) {
  PersonKnowledgeList(filter: $filter) {
    id
    type
    mgsaDimension
    displayName
    description
    source
    sourceRef
    sourceDate
    confidence
    __typename
  }
}
    `;

export function useP_PersonKnowledgeListQuery(options?: Omit<Urql.UseQueryArgs<P_PersonKnowledgeListQueryVariables>, 'query'>) {
  return Urql.useQuery<P_PersonKnowledgeListQuery, P_PersonKnowledgeListQueryVariables>({ query: P_PersonKnowledgeListDocument, ...options });
};